module.exports = "<div class=\"modal-header\">\n  <button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"cancel()\">&times;</button>\n  <h2 class=\"modal-title\">Terms &amp; Conditions</h2>\n</div>\n<div class=\"modal-body terms-modal-body\" ng-bind-html=\"terms\">\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/services/modal/terms/terms.html
// module id = 886
// module chunks = 1